import { EventTracking, EventType } from '@app/tracking';
var LinkedInInsight = /** @class */ (function () {
    function LinkedInInsight(partnerId, leadConversionId, scriptPath) {
        if (scriptPath === void 0) { scriptPath = 'https://snap.licdn.com/li.lms-analytics/insight.min.js'; }
        this.partnerId = partnerId;
        this.leadConversionId = leadConversionId;
        window._linkedin_partner_id = partnerId;
        window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || [];
        window._linkedin_data_partner_ids.push(window._linkedin_partner_id);
        var scriptTag = document.createElement("script");
        scriptTag.async = true;
        scriptTag.src = scriptPath;
        document.body.appendChild(scriptTag);
        if (window.laravelDebug) {
            console.log("\u2705 LinkedIn Tracking initialized for \"" + partnerId + "\"");
        }
        this.registerListeners();
    }
    LinkedInInsight.prototype.registerListeners = function () {
        var _this = this;
        // Form success
        EventTracking.listen(EventType.FormSuccess, function (_a) {
            var form = _a.form;
            _this.generatePixel("https://px.ads.linkedin.com/collect/?pid=" + _this.partnerId + "&conversionId=" + _this.leadConversionId + "&fmt=gif");
        });
    };
    LinkedInInsight.prototype.generatePixel = function (src) {
        var pixel = document.createElement("img");
        pixel.height = 1;
        pixel.width = 1;
        pixel.style.display = 'none';
        pixel.src = src;
    };
    return LinkedInInsight;
}());
export default LinkedInInsight;
